import { SimpleMutationOptions, useBaseMutation } from "../baseMutation";
import { RemoveFolderFileByIdRequest, RemoveFolderFileByIdResponse } from "@maven-rest/docs/FolderFile.dto";
import { FolderFileUrl } from "@maven-rest/docs/FolderFile.url";

export function useRemoveFolderFileMutation(
  pathVariable: Pick<RemoveFolderFileByIdRequest, "fileId">,
  options?: SimpleMutationOptions<RemoveFolderFileByIdResponse, RemoveFolderFileByIdRequest>
) {
  return useBaseMutation({
    fnOption: {
      url: FolderFileUrl.removeFolderFileById(pathVariable.fileId),
    },
    ...options,
  });
}
